import { render, staticRenderFns } from "./EmptyCallView.vue?vue&type=template&id=42f1f572&"
import script from "./EmptyCallView.vue?vue&type=script&lang=js&"
export * from "./EmptyCallView.vue?vue&type=script&lang=js&"
import style0 from "./EmptyCallView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports